import React from "react";
import FormattedMessage from "@irati/utils/lang";
import { StyledTab, StyledTabs } from "./styled";
import { SelectedTab } from "./types";
var CompanyNewsContentHeader = function (_a) {
    var currentTab = _a.currentTab, isPreview = _a.isPreview, setTab = _a.setTab;
    return (React.createElement(StyledTabs, null,
        React.createElement(StyledTab, { onClick: function () {
                if (!isPreview) {
                    setTab(SelectedTab.IMAGE);
                }
            }, isActive: currentTab === SelectedTab.IMAGE },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.image.title" })),
        React.createElement(StyledTab, { onClick: function () {
                if (!isPreview) {
                    setTab(SelectedTab.VIDEO);
                }
            }, isActive: currentTab === SelectedTab.VIDEO },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.video.title" })),
        React.createElement(StyledTab, { onClick: function () {
                if (!isPreview) {
                    setTab(SelectedTab.TEMPLATE);
                }
            }, isActive: currentTab === SelectedTab.TEMPLATE },
            React.createElement(FormattedMessage, { id: "platform.homepage.companyNews.newContent.template.title" }))));
};
export default CompanyNewsContentHeader;
